import { cn } from "@/lib/utils";

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode;
}

export function ChartCard({
  title,
  subtitle,
  children,
  className,
  actions,
}: ChartCardProps) {
  return (
    <div className={cn("surface-elevated p-5 animate-fade-in", className)}>
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="heading-subsection text-foreground">{title}</h3>
          {subtitle && <p className="text-caption mt-0.5">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      <div>{children}</div>
    </div>
  );
}
